module.exports = __webpack_public_path__ + "style/img/SP_icon_Work.e882ed01.png";